import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { About } from "./about";
import { Services, LdServices } from "./ldserv";
import { Features } from "./features";
import { Team } from "./Team";
import { Gallery } from "./gallery";
import { WhyChooseUs } from "./WhyChooseUs";
import { Slidershow } from "./slidershow";
import { scrollToSectionId } from "../utils/scrollToSection";
import "../App.css";

const Landing = () => {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace(/^#/, "");
    if (!id) return;
    const timer = window.setTimeout(() => scrollToSectionId(id), 120);
    return () => clearTimeout(timer);
  }, [location.pathname, location.hash, i18n.language]);

  return (
    <div>
      <Slidershow />
      <About />
      <WhyChooseUs />
      <LdServices />
      <Services />
      <Features />
      <Team />
      <Gallery />
    </div>
  );
};

export default Landing;
